import { SourceContextTable } from 'features/libra/inspectionPlanning/sourceContext'
import { z } from 'zod'

export const workPackConfigSchema = z.object({
  title: z.string(),
  buttonLabel: z.string(),
  filenamePrefix: z.string(),
  preparationStepId: z.string(),
  purpose: z.string(),
  executionStepId: z.string().optional(),
  performedField: z.string().optional(),
  references: z
    .array(
      z.object({
        label: z.string(),
        value: z.string().optional(),
        sourceField: z.string().optional(),
      })
    )
    .default([]),
  headings: z
    .object({
      contents: z.string().default('Table of contents'),
      references: z.string().default('References'),
      asset: z.string().default('Asset details - data gathering'),
      plan: z.string().default('Inspection plan'),
      findings: z.string().default('Findings'),
    })
    .default({
      contents: 'Table of contents',
      references: 'References',
      asset: 'Asset details - data gathering',
      plan: 'Inspection plan',
      findings: 'Findings',
    }),
})
export type WorkPackConfig = z.infer<typeof workPackConfigSchema>

export type WorkPackSection = {
  title: string
  rows: { label: string; value: string }[]
  tables?: SourceContextTable[]
}

export type WorkPackChapter = {
  id: string
  title: string
  sections: WorkPackSection[]
  drawing?: WorkPackDrawing
}

export type WorkPackDrawing = {
  id: string
  marks: {
    title: string
    description: string
    color: string
    drawing_bounds: {
      x_start: number
      y_start: number
      x_end: number
      y_end: number
    }
  }[]
}

export type PlanningWorkPack = {
  title: string
  purpose: string
  filename: string
  ticketId: string
  version: number
  generatedAt: string
  cover: WorkPackSection
  contentsTitle: string
  chapters: WorkPackChapter[]
  sections: WorkPackSection[]
  zones: { sourceZoneId: string; title: string; sections: WorkPackSection[] }[]
  drawings: WorkPackDrawing[]
}

export type WorkPackImage = { id: string; name: string; dataUrl: string }
